import React, { useEffect, useState } from 'react';
import NavigationBar from '../nav_bar/navigation_bar';
import './about.css';

const About = () => {
    const [about, setAbout] = useState(null);

    useEffect(() => {
        fetch('/upload/data/about.json')
            .then((res) => res.json())
            .then((data) => setAbout(data))
            .catch((err) => console.error('Failed to load about:', err));
    }, []);

    return (
        <div className="about-page">
            <NavigationBar />

            <main className="about-main">
                <section className="about-section-3d">
                    <div className="about-container-3d">
                        <div className="about-header-3d">
                            <h1 className="about-title-3d">{about ? about.title : 'About Me'}</h1>
                            <p className="about-subtitle-3d">{about ? about.subtitle : 'Get to know more about my journey and passion'}</p>
                        </div>

                        <div className="about-content-3d">
                            <div className="about-text-container-3d">
                                <div className="about-text-3d">
                                    {about ? (
                                        about.paragraphs.map((p, idx) => (
                                            <p key={idx}>{p}</p>
                                        ))
                                    ) : (
                                        <p>Loading...</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

        </div>
    );
};

export default About;